import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  mfaBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: '#fff',
    borderRadius: '12px',
    width: '90%',
    maxWidth: '800px',
    boxSizing: 'border-box',
    padding: '40px',
    margin: '40px auto',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      padding: '24px',
      margin: '20px auto',
      borderRadius: '12px 12px 0 0'
    }
  },
  canalCard: {
    width: '100%',
    marginBottom: '16px',
    border: '2px solid #E8F5E8',
    borderRadius: '12px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '& .MuiCardContent-root:last-child': {
      [theme.breakpoints.down('sm')]: {
        padding: '12px'
      },
      [theme.breakpoints.up('md')]: {
        padding: '20px'
      }
    },
    '&:hover': {
      borderColor: theme.palette.secondary.main,
      boxShadow: '0 4px 12px rgba(138, 197, 185, 0.15)',
      transform: 'translateY(-2px)'
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: '12px'
    },
    [theme.breakpoints.up('md')]: {
      marginBottom: '20px'
    }
  },
  canalContent: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px',
    [theme.breakpoints.down('sm')]: {
      padding: '12px'
    },
    [theme.breakpoints.up('md')]: {
      padding: '20px'
    }
  },
  canalIcon: {
    // width: '40px',
    // height: '40px',
    // borderRadius: '50%',
    // background: '#ddf9f4d9',
    // fontSize: '20px',

    fontSize: '24px',
    alignSelf: 'flex-start',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '16px',
    color: theme.palette.secondary.main,
    [theme.breakpoints.down('sm')]: {
      width: '36px',
      height: '36px',
      // fontSize: '18px',
      marginTop: '-4px',
      marginRight: '12px'
    },
    [theme.breakpoints.up('md')]: {
      width: '44px',
      height: '44px'
      // fontSize: '22px'
    }
  },
  canalInfo: {
    flex: 1
  },
  canalTitle: {
    // fontSize: '16px',
    fontWeight: 600,
    color: theme.palette.primary.main,
    marginBottom: '4px'
    // [theme.breakpoints.down('sm')]: {
    //   fontSize: '14px'
    // },
    // [theme.breakpoints.up('md')]: {
    //   fontSize: '18px'
    // }
  },
  canalDescription: {
    fontSize: '14px',
    color: '#666',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '15px'
    }
  },
  canalArrow: {
    color: theme.palette.secondary.main,
    fontSize: '20px'
  },
  helpText: {
    fontSize: '14px',
    // color: '#666',
    color: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    }
  },
  helpSubtext: {
    fontSize: '12px',
    // color: '#999',
    color: theme.palette.primary.main,
    marginTop: '4px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '11px'
    }
  }
}))
